import { Box, CardHeader, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Alert, Autocomplete } from "@mui/material";
import axios from "axios";
import * as React from "react";
import ReactCountryFlag from "react-country-flag";
import { NavLink } from "react-router-dom";
import { Avatar } from "../../../components/Avatar";
import { LeagueShield } from "../../../components/League";
import { LoadingWrapper } from "../../../components/LoadingWrapper";
import { Config } from "../../../config/config";
import { CountryCodes } from "../../../utils/countryCodes";
import { Helpers } from "../../../utils/helpers";

export class DashboardTopUsers extends React.Component<any, any> {

	constructor(props) {
		super(props);

		this.state = {
			users: [],
			loading: true,
			error: null,
			filter: {
				country: null,
			}
        };
    }

	componentDidMount() {
		this.loadStats();
	}

	loadStats() {
        this.setState({ loading: true }, async () => {
			try {
				const response = await axios.post(`${Config.getInstance.apiUrl}/api/dashboard/top_players`, {
					...this.state.filter
				}, {
					headers: {
						Authorization: Helpers.getSessionId(),
					},
				});

				this.setState({
					users: response.data.list,
					loading: false,
				});
			} catch (error) {
				this.setState({
					error: error.message,
					loading: false,
				});
			}
		})
    }

	handleFilter(property: string, value: any) {
        const filterForm = {...this.state.filter};
        filterForm[property] = value;

        this.setState({ filter: filterForm }, () => {
			this.loadStats();
		});
    }

	renderCardHeaderActions() {
		return <Grid container spacing={2}>
			<Grid item xs={4}>
				<Autocomplete
					style={{ display: "inline-block", minWidth: 200, padding: "8px 5px 0 0" }}
					onChange={(_, newValue) => this.handleFilter("country", newValue)}
					value={this.state.filter.country}
					options={CountryCodes.sort((a, b) => -b.name.localeCompare(a.name))}
					getOptionLabel={option => option?.name || ""}
					renderOption={(props, item) => (
						<Box component="li" {...props}>
							<ReactCountryFlag countryCode={item.code} svg={true}/>
							<span style={{ marginLeft: 7, fontSize: 15 }}>{item.name}</span>
						</Box>
					)}
					renderInput={(params) =>
						<TextField
							{...params}
							label="Country"
							variant="outlined"
							size="small"
						/>
					}
				/>
			</Grid>
		</Grid>;
	}

	renderTableBody() {
		if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={8}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

		if ((this.state?.users || []).length === 0) {
			return <TableCell colSpan={8}>
				<Alert severity="info">No users found</Alert>
			</TableCell>
		}

		return (this.state?.users || []).map(item => (
			<TableRow key={item.id} hover={true} style={{ height: 100 }}>
				<TableCell>{Avatar(item)}</TableCell>
				<TableCell>
					<NavLink to={`/players/${item.id}`}>
						{item.name}
					</NavLink>
				</TableCell>
				<TableCell>{item.headquarter_level}</TableCell>
				<TableCell>{item.vip_system.level}</TableCell>
				<TableCell>{item.rubies}</TableCell>
				<TableCell>
					<ReactCountryFlag countryCode={item.country} svg={true}/>
					<span style={{ marginLeft: 5, fontSize: 12 }}>{item.country}</span>
				</TableCell>
				<TableCell>
					{LeagueShield({
						rank: item.rank,
						showRank: true,
					})}
				</TableCell>
				<TableCell>
					{Helpers.fancyTimeFormat(item.play_time, {
						hideSeconds: true
					})}
				</TableCell>
			</TableRow>
		))
	}

	render() {
		return <Paper elevation={0}>
			<div>
				<CardHeader
					title={<Typography variant="h6">Top 10 users</Typography>}
					action={this.renderCardHeaderActions()}
				/>

				<Table>
					<TableHead>
						<TableRow>
							<TableCell style={{ width: 50, padding: "4px 16px" }}></TableCell>
							<TableCell style={{ padding: "4px 16px" }}>Username</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px" }}>Core</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px" }}>VIP</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px" }}>Gold</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px" }}>Country</TableCell>
							<TableCell style={{ width: 50, padding: "4px 16px" }}>League</TableCell>
							<TableCell style={{ width: 150, padding: "4px 16px" }}>Time played</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{this.renderTableBody()}
					</TableBody>
				</Table>
			</div>
		</Paper>;
	}
}
